import Http from '../utils/http'
import store from 'store/index'

export const getAll = () => {
    return Http.get(`/company/exchange-rate`)
       .then(response => {
           store.dispatch('saveCurrencies', response.data)
           return response.data
       })
}

export const update = (payload) => {
    return Http.put(`/company/exchange-rate`, payload)
       .then(response => {
           store.dispatch('saveCurrencies', response.data)
           return response.data
       })
}

export const fixerIoSync = (payload) => {
    return Http.put(`/company/fixer-io-sync`, payload)
       .then(response => {
           store.dispatch('saveCurrencies', response.data)
           return response.data
       })
}



// WEBPACK FOOTER //
// ./src/services/exchange-rate.js